import { FieldValues, UseFieldArrayAppend } from 'react-hook-form';

import { AddFieldButton } from '@kanda-libs/ks-component-ts';

import { BASE_INCOME } from './constants';

export interface AddIncomeItemButtonProps {
  append: UseFieldArrayAppend<FieldValues, string>;
}

const AddIncomeItemButton: React.FunctionComponent<AddIncomeItemButtonProps> =
  function ({ append }) {
    return (
      <div className="mx-auto border border-dashed border-neutral-300 rounded-lg justify-center pt-3 px-4 mb-5 mt-2">
        <AddFieldButton
          label="Add additional income information"
          onClick={() => append(BASE_INCOME)}
        />
      </div>
    );
  };

export default AddIncomeItemButton;
